import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0380525c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ガウス整数の除法", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 入力 ", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "math" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"50px"} }, ",", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "math" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"50px"} }, ",", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"20px"} }, ",", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 計算結果 ", -1))
const _hoisted_12 = { class: "mtable" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " z / w ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_15 = { class: "mtd" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_18 = { class: "mtd" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_21 = { class: "mtd" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_25 = { class: "mtd" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_29 = { class: "mtd" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "商 q"),
  /*#__PURE__*/_createElementVNode("th", null, "余り r"),
  /*#__PURE__*/_createElementVNode("th", null, "N(r)"),
  /*#__PURE__*/_createElementVNode("th", null, "表示")
], -1))
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "図示", -1))
const _hoisted_35 = { style: {"width":"95vw","height":"70vh","margin":"auto","background-color":"#fff","position":"relative"} }
const _hoisted_36 = ["width", "height", "viewBox"]
const _hoisted_37 = ["d"]
const _hoisted_38 = ["x", "y", "font-size"]
const _hoisted_39 = ["x", "y", "font-size"]
const _hoisted_40 = ["x", "y", "font-size"]
const _hoisted_41 = ["x1", "x2", "y1", "y2"]
const _hoisted_42 = ["y1", "y2", "x1", "x2"]
const _hoisted_43 = ["x1", "x2", "y1", "y2"]
const _hoisted_44 = ["y1", "y2", "x1", "x2"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["x", "y", "font-size"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = ["x", "y", "font-size"]
const _hoisted_49 = { key: 2 }
const _hoisted_50 = ["x", "y", "font-size"]
const _hoisted_51 = { key: 3 }
const _hoisted_52 = ["x", "y", "font-size"]
const _hoisted_53 = ["x1", "y1", "x2", "y2"]
const _hoisted_54 = ["cx", "cy", "r"]
const _hoisted_55 = ["cx", "cy"]
const _hoisted_56 = ["d"]
const _hoisted_57 = ["cx", "cy", "r"]
const _hoisted_58 = ["x", "y", "font-size"]
const _hoisted_59 = ["x", "y", "font-size"]
const _hoisted_60 = ["x", "y", "font-size"]
const _hoisted_61 = ["x", "y", "font-size"]
const _hoisted_62 = ["x", "y", "font-size"]
const _hoisted_63 = ["cx", "cy", "r"]
const _hoisted_64 = ["x", "y", "font-size"]
const _hoisted_65 = ["x", "y", "font-size"]
const _hoisted_66 = { class: "selectbox" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "buttonbox"
}

import { ref, onMounted, computed } from 'vue';
import { Gauss, QGauss, mkQlist, qlistI } from '@/composable/lib.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'GaussDiv',
  setup(__props) {

const input = ref(true);
const mode = ref('normal');
const moving = ref(false);
const z = ref(new Gauss(1,0));
const w = ref(new Gauss(1,0));
const c = ref(new QGauss(new Gauss(0,0), 1));
const pz = ref(new Gauss(1,0));
const pw = ref(new Gauss(1,0));
const qlist= ref(new Array<qlistI>());
const message= ref('');
const width= ref(1920);
const height= ref(1080);

onMounted( () => {
  height.value = window.innerHeight * 0.7;
  width.value = window.innerWidth * 0.95;
  window.addEventListener('resize', () => {
    height.value = window.innerHeight * 0.7;
    width.value = window.innerWidth * 0.95;
  });
});

const calc =  function(){
  if(z.value.error || w.value.error){
    message.value ='実部、虚部とも整数を入力してください。';
    return;
  }
  if(w.value.isZero){
    message.value ='0で割ることはできません。';
    return;
  }
  message.value = '';
  c.value = z.value.div(w.value);
  pz.value = z.value.copy();
  pw.value = w.value.copy();
  input.value = false;
  mode.value = 'normal';
  qlist.value = mkQlist(z.value,w.value);
};

const phase = ref(0);
const zphase = ref(0);
let nextMode = 'normal';
let timer = 0;

const newMode = function(v:string){
  nextMode = v;
  moving.value = true;
  if(mode.value == 'normal' && v == 'quot'){
    timer = setInterval(transform,20);
  }else{
    timer = setInterval(ztransform,20);
  }
};

// zoom in/out
const ztransform = function(){
  zphase.value += 1;
  if(zphase.value >= 100){
    clearInterval(timer);
    if(mode.value == 'quot' && nextMode == 'normal'){
      timer = setInterval(transform,20);
    }else{
      mode.value = nextMode;
      moving.value = false;
      zphase.value = 0;
      phase.value = 0;
    }
  }
};

// normal <-> quot
const transform = function(){
  phase.value += 1;
  const t = ( (mode.value == 'normal') ? phase.value : (100 - phase.value) ) * 0.01;
  pz.value.r = z.value.r*(1-t) + c.value.r*t;
  pz.value.i = z.value.i*(1-t) + c.value.i*t;
  pw.value.r = w.value.r*(1-t) + t;
  pw.value.i = w.value.i*(1-t);
  if(phase.value >= 100){
    clearInterval(timer);
    if(mode.value =='normal' && nextMode == 'quot'){
      timer = setInterval(ztransform,20);
    }else{
      mode.value = nextMode;
      moving.value = false;
      zphase.value = 0;
      phase.value = 0;
    }
  }
};

// computed values

const qlistShow = computed( () =>  qlist.value.filter( (e) => e.show ) );

const sgeom = computed( () => {
  let obj = {};
  const r = Math.sqrt(w.value.norm) + 0.5;
  const r1 = width.value / height.value;
  let minx = -10;
  let miny = -10;
  let maxx = 10;
  let maxy = 10;
  for(const tmpMode of ['normal', 'zoom', 'quot', 'qzoom' ]){
    if(tmpMode == 'normal'){
      if(z.value.r < 0){
	minx = z.value.r -r;
	maxx = r;
      }else{
	minx = -r;
	maxx = z.value.r + r;
      }
      if(z.value.i < 0){
	miny = z.value.i -r;
	maxy = r;
      }else{
	miny = -r;
	maxy = z.value.i + r;
      }
    }else if(tmpMode == 'quot'){
      const rr = c.value.n.r / c.value.d;
      const ii = c.value.n.i / c.value.d;
      if(rr < 0){
	minx = rr -1.1;
	maxx = 1.1;
      }else{
	minx = -1.1;
	maxx =rr + 1.1;
      }
      if(ii < 0){
	miny = ii - 1.1;
	maxy = 1.1;
      }else{
	miny = -1.1;
	maxy = ii + 1.1;
      }
    }else if(tmpMode == 'zoom'){
      minx = z.value.r - r;
      maxx = z.value.r + r;
      miny = z.value.i - r;
      maxy = z.value.i + r;
    }else if(tmpMode == 'qzoom'){
      minx = c.value.n.r/c.value.d -1.1;
      maxx = c.value.n.r/c.value.d +1.1;
      miny = c.value.n.i/c.value.d -1.1;
      maxy = c.value.n.i/c.value.d +1.1;
    }
    
    const r2 = (maxx - minx) / (maxy - miny);
    if(r1 > r2){
      const d = (r1*(maxy - miny) - (maxx - minx)) / 2;
      maxx += d;
      minx -= d;
    }else{
      const d = ((maxx - minx)/r1 - (maxy - miny)) / 2;
      maxy += d;
      miny -= d;
    }
    const subobj = {
      minx: minx,
      maxx: maxx,
      miny: miny,
      maxy: maxy,
      vb: `${minx}, ${-maxy}, ${maxx - minx}, ${maxy - miny}`,
      scale: width.value/(maxx - minx)
    };
    obj[tmpMode] = subobj;
  }
  return(obj);
});

const geom = computed(() => {
  if(zphase.value == 0){
    return(sgeom.value[mode.value]);
  }else{
    const minx = (sgeom.value[mode.value].minx*(100-zphase.value) + sgeom.value[nextMode].minx*zphase.value)/100;
    const maxx = (sgeom.value[mode.value].maxx*(100-zphase.value) + sgeom.value[nextMode].maxx*zphase.value)/100;
    const miny = (sgeom.value[mode.value].miny*(100-zphase.value) + sgeom.value[nextMode].miny*zphase.value)/100;
    const maxy = (sgeom.value[mode.value].maxy*(100-zphase.value) + sgeom.value[nextMode].maxy*zphase.value)/100;
    return({
      minx,
      maxx,
      miny,
      maxy,
      vb: `${minx}, ${-maxy}, ${maxx - minx}, ${maxy - miny}`,
      scale: width.value/(maxx - minx)
    });
  }
});

const mark = computed( () => {
  const obj = { x1:[], x2:[], y1:[], y2:[] };
  let skip = 1;
  let rate = 2;
  while( width.value*skip / (geom.value.maxx - geom.value.minx) < 40){
    rate = (rate == 2) ? 5 : 2;
    skip *= rate;
  }
  for(let x = skip; x < geom.value.maxx; x+=skip){
    obj.x1.push(x);
  }
  for(let x = -skip; x > geom.value.minx; x-=skip){
    obj.x1.push(x);
  }
  for(let y = skip; y < geom.value.maxy; y+=skip){
    obj.y1.push(y);
  }
  for(let y = -skip; y > geom.value.miny; y-=skip){
    obj.y1.push(y);
  }
  
  if(skip > 1){
    skip /= rate;
    for(let x = skip; x < geom.value.maxx; x+=skip){
      obj.x2.push(x);
    }
    for(let x = -skip; x > geom.value.minx; x-=skip){
      obj.x2.push(x);
    }
    for(let y = skip; y < geom.value.maxy; y+=skip){
      obj.y2.push(y);
    }
    for(let y = -skip; y > geom.value.miny; y-=skip){
      obj.y2.push(y);
    }
  }
  return(obj);
});

const axisStyle = computed( () => {
  return({ stroke: 'black', strokeWidth: 1.5/geom.value.scale, fill:'none' });
});
const axisPath = computed( () => {
  let d = [];
  const h = 10 / geom.value.scale;
  if(geom.value.minx < 0 && geom.value.maxx > 0){
    d.push(`M 0,${-geom.value.miny} L 0,${-geom.value.maxy} m ${-h},${h} l ${h},${-h} l ${h},${h}`);
  }
  if(geom.value.miny < 0 && geom.value.maxy > 0){
    d.push(`M ${geom.value.minx},0 L ${geom.value.maxx},0 m ${-h},${-h} l ${h},${h} l ${-h},${h}`);
  }
  return(d.join(' '));
});
const dashStyle = computed( () => {
  return({ stroke: 'black', strokeWidth: 1/geom.value.scale,
	   strokeDasharray: `${4/geom.value.scale} ${4/geom.value.scale}`, fill:'none' });
});
const markStyle = computed( () => {
  return({ stroke: 'black', strokeWidth: 1/geom.value.scale, fill:'none' });
});
const wMesh = computed( () => {
  let ar = [];
  const n = Math.ceil((Math.abs(pz.value.r) + Math.abs(pz.value.i)) / Math.sqrt(pw.value.norm)) + 3;
  for(let i=-n; i<n; i+=1){
    const p = pw.value.mul(new Gauss(i,-n));
    const q = pw.value.mul(new Gauss(i,n));
    ar.push({id: `R${i}`, x1:p.r, y1:p.i, x2:q.r, y2:q.i});
  }
  for(let i=-n; i<n; i+=1){
    const p = pw.value.mul(new Gauss(-n,i));
    const q = pw.value.mul(new Gauss(n,i));
    ar.push({id: `I${i}`, x1:p.r, y1:p.i, x2:q.r, y2:q.i});
  }
  return(ar);
});
const meshStyle = computed( () => {
  return({ stroke: 'green', strokeWidth: 2/geom.value.scale, fill:'none' });
});
const rStyle = computed( () => {
  return({ stroke: 'red', strokeWidth: 2/geom.value.scale, fill:'none' });
});
const rStyle2 = computed( () => {
  return({ stroke: 'black', strokeWidth: 1.5/geom.value.scale, fill:'none' });
});
const qStyle = computed( () => {
  return {
    stroke: 'red',
    strokeWidth: 2/geom.value.scale,
    strokeDasharray: `${4/geom.value.scale} ${4/geom.value.scale}`,
    fill:'none'
  };
});

const showValue = ref(true);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (input.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" 実部、虚部とも整数を入力してください。 "),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createTextVNode(" z = "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((z.value.r) = $event)),
                  class: _normalizeClass({error:z.value.Rerror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    z.value.r,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode(" + "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((z.value.i) = $event)),
                  class: _normalizeClass({error:z.value.Ierror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    z.value.i,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode("i ")
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(" w = "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((w.value.r) = $event)),
                  class: _normalizeClass({error:w.value.Rerror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    w.value.r,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode(" + "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((w.value.i) = $event)),
                  class: _normalizeClass({error:w.value.Ierror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    w.value.i,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode("i ")
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(" z = " + _toDisplayString(z.value.txt), 1),
              _hoisted_6,
              _createTextVNode(" w = " + _toDisplayString(w.value.txt), 1)
            ]),
            _createElementVNode("button", { onClick: calc }, "計算"),
            _createTextVNode(" " + _toDisplayString(message.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" z = " + _toDisplayString(z.value.txt), 1),
              _hoisted_9,
              _createTextVNode(" w = " + _toDisplayString(w.value.txt), 1),
              _hoisted_10,
              _createTextVNode(" N(w) = " + _toDisplayString(w.value.norm), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (input.value = true))
            }, "値の変更")
          ])),
      (! input.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _hoisted_14,
                  _createElementVNode("td", _hoisted_15, _toDisplayString(z.value.fencedTxt) + " / " + _toDisplayString(w.value.fencedTxt), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("td", _hoisted_18, " { " + _toDisplayString(z.value.fencedTxt) + " × " + _toDisplayString(w.value.conj.fencedTxt) + " } / " + _toDisplayString(w.value.norm), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(z.value.mul(w.value.conj).fencedTxt) + " / " + _toDisplayString(w.value.norm), 1)
                ]),
                (w.value.norm != c.value.d)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      _createElementVNode("td", _hoisted_25, _toDisplayString(c.value.txt), 1)
                    ]))
                  : _createCommentVNode("", true),
                (c.value.d != 1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("td", _hoisted_29, _toDisplayString(c.value.intTxt), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("table", null, [
              _hoisted_30,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qlist.value, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.q.txt,
                  onClick: ($event: any) => (entry.show = ! entry.show)
                }, [
                  _createElementVNode("td", {
                    class: "math",
                    style: _normalizeStyle(entry.valid ? '' : 'background-color:#bbb')
                  }, _toDisplayString(entry.q.txt), 5),
                  _createElementVNode("td", {
                    class: "math",
                    style: _normalizeStyle(entry.valid ? '' : 'background-color:#bbb')
                  }, _toDisplayString(entry.r.txt), 5),
                  _createElementVNode("td", {
                    class: "math",
                    style: _normalizeStyle(entry.valid ? '' : 'background-color:#bbb')
                  }, [
                    _createTextVNode(_toDisplayString(entry.n) + " ", 1),
                    (! entry.valid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, " (不適) "))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((entry.show) = $event),
                      type: "checkbox"
                    }, null, 8, _hoisted_33), [
                      [_vModelCheckbox, entry.show]
                    ])
                  ])
                ], 8, _hoisted_31))
              }), 128))
            ]),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(), _createElementBlock("svg", {
                width: width.value,
                height: height.value,
                viewBox: _unref(geom).vb
              }, [
                _createElementVNode("path", {
                  style: _normalizeStyle(_unref(axisStyle)),
                  d: _unref(axisPath)
                }, null, 12, _hoisted_37),
                _createElementVNode("text", {
                  x: _unref(geom).maxx - 30/_unref(geom).scale,
                  y: 30/_unref(geom).scale,
                  "font-size": 20/_unref(geom).scale
                }, " Re ", 8, _hoisted_38),
                _createElementVNode("text", {
                  x: -30/_unref(geom).scale,
                  y: -_unref(geom).maxy + 30/_unref(geom).scale,
                  "font-size": 20/_unref(geom).scale
                }, " Im ", 8, _hoisted_39),
                _createElementVNode("text", {
                  x: -15/_unref(geom).scale,
                  y: 20/_unref(geom).scale,
                  "font-size": 20/_unref(geom).scale
                }, " 0 ", 8, _hoisted_40),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).x1, (x) => {
                  return (_openBlock(), _createElementBlock("line", {
                    key: x,
                    style: _normalizeStyle(_unref(dashStyle)),
                    x1: x,
                    x2: x,
                    y1: -_unref(geom).miny,
                    y2: -_unref(geom).maxy
                  }, null, 12, _hoisted_41))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).y1, (y) => {
                  return (_openBlock(), _createElementBlock("line", {
                    key: y,
                    style: _normalizeStyle(_unref(dashStyle)),
                    y1: -y,
                    y2: -y,
                    x1: _unref(geom).minx,
                    x2: _unref(geom).maxx
                  }, null, 12, _hoisted_42))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).x2, (x) => {
                  return (_openBlock(), _createElementBlock("line", {
                    key: x,
                    style: _normalizeStyle(_unref(markStyle)),
                    x1: x,
                    x2: x,
                    y1: -5/_unref(geom).scale,
                    y2: 5/_unref(geom).scale
                  }, null, 12, _hoisted_43))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).y2, (y) => {
                  return (_openBlock(), _createElementBlock("line", {
                    key: y,
                    style: _normalizeStyle(_unref(markStyle)),
                    y1: -y,
                    y2: -y,
                    x1: -5/_unref(geom).scale,
                    x2: 5/_unref(geom).scale
                  }, null, 12, _hoisted_44))
                }), 128)),
                (_unref(geom).miny < 0 && _unref(geom).maxy > 0)
                  ? (_openBlock(), _createElementBlock("g", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).x1, (x) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: x,
                          x: x,
                          y: 20/_unref(geom).scale,
                          "font-size": 20/_unref(geom).scale,
                          "text-anchor": "middle"
                        }, _toDisplayString(x), 9, _hoisted_46))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("g", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).x1, (x) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: x,
                          x: x,
                          y: -_unref(geom).miny-3/_unref(geom).scale,
                          "font-size": 20/_unref(geom).scale,
                          "text-anchor": "middle"
                        }, _toDisplayString(x), 9, _hoisted_48))
                      }), 128))
                    ])),
                (_unref(geom).minx < 0 && _unref(geom).maxx > 0)
                  ? (_openBlock(), _createElementBlock("g", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).y1, (y) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: y,
                          x: -3/_unref(geom).scale,
                          y: -y+10/_unref(geom).scale,
                          "font-size": 20/_unref(geom).scale,
                          "text-anchor": "end"
                        }, _toDisplayString(y), 9, _hoisted_50))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("g", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mark).y1, (y) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: y,
                          x: _unref(geom).minx +3/_unref(geom).scale,
                          y: -y+10/_unref(geom).scale,
                          "font-size": 20/_unref(geom).scale
                        }, _toDisplayString(y), 9, _hoisted_52))
                      }), 128))
                    ])),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wMesh), (l, i) => {
                  return (_openBlock(), _createElementBlock("line", {
                    key: i,
                    style: _normalizeStyle(_unref(meshStyle)),
                    x1: l.x1,
                    y1: -l.y1,
                    x2: l.x2,
                    y2: -l.y2
                  }, null, 12, _hoisted_53))
                }), 128)),
                _createElementVNode("circle", {
                  style: {"fill":"green"},
                  cx: pw.value.r,
                  cy: -pw.value.i,
                  r: 5/_unref(geom).scale
                }, null, 8, _hoisted_54),
                ((mode.value == 'quot' || mode.value == 'qzoom') && ! moving.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_unref(qlistShow), (item, i) => {
                      return (_openBlock(), _createElementBlock("circle", {
                        key: i,
                        style: _normalizeStyle(_unref(qStyle)),
                        cx: item.q.mul(pw.value).r,
                        cy: -item.q.mul(pw.value).i,
                        r: 1
                      }, null, 12, _hoisted_55))
                    }), 128))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qlistShow), (item, i) => {
                  return (_openBlock(), _createElementBlock("path", {
                    key: i,
                    style: _normalizeStyle(item.valid ? _unref(rStyle) : _unref(rStyle2)),
                    d: `M ${item.q.mul(pw.value).r},${-item.q.mul(pw.value).i} L ${pz.value.r},${-pz.value.i}`
                  }, null, 12, _hoisted_56))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qlistShow), (item, i) => {
                  return (_openBlock(), _createElementBlock("circle", {
                    key: i,
                    style: _normalizeStyle(item.valid ? 'fill:orange' : 'fill:black'),
                    cx: item.q.mul(pw.value).r,
                    cy: -item.q.mul(pw.value).i,
                    r: 5/_unref(geom).scale
                  }, null, 12, _hoisted_57))
                }), 128)),
                ((mode.value == 'normal' || mode.value == 'zoom') && ! moving.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createElementVNode("text", {
                        style: {"fill":"green"},
                        x: w.value.r + 5/_unref(geom).scale,
                        y: -w.value.i -5/_unref(geom).scale,
                        "font-size": 30/_unref(geom).scale
                      }, [
                        _createTextVNode(" w "),
                        (showValue.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" = " + _toDisplayString(w.value.txt), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_58),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qlistShow), (item, i) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: i,
                          style: _normalizeStyle(item.valid ? 'fill:orange' : 'fill:black'),
                          x: item.q.mul(w.value).r + 5/_unref(geom).scale,
                          y: -item.q.mul(w.value).i +35/_unref(geom).scale,
                          "font-size": 30/_unref(geom).scale
                        }, [
                          _createTextVNode(" wq "),
                          (showValue.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" = " + _toDisplayString(w.value.mul(item.q).txt), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_59))
                      }), 128)),
                      (showValue.value)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(qlistShow), (item, i) => {
                            return (_openBlock(), _createElementBlock("text", {
                              key: i,
                              style: _normalizeStyle(item.valid ? 'fill:red' : 'fill:black'),
                              x: (item.q.mul(w.value).r + z.value.r)/2,
                              y: (-item.q.mul(w.value).i -z.value.i )/2 - 5/_unref(geom).scale,
                              "font-size": 30/_unref(geom).scale
                            }, " r = " + _toDisplayString(item.r.txt), 13, _hoisted_60))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                ((mode.value == 'quot' || mode.value == 'qzoom') && ! moving.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("text", {
                        style: {"fill":"green"},
                        x: 1 + 5/_unref(geom).scale,
                        y: - 5/_unref(geom).scale,
                        "font-size": 30/_unref(geom).scale
                      }, " 1 ", 8, _hoisted_61),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qlistShow), (item, i) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: i,
                          style: _normalizeStyle(item.valid ? 'fill:orange' : 'fill:black'),
                          x: item.q.r + 5/_unref(geom).scale,
                          y: -item.q.i - 5/_unref(geom).scale,
                          "font-size": 30/_unref(geom).scale
                        }, [
                          _createTextVNode(" q "),
                          (showValue.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" = " + _toDisplayString(item.q.txt), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_62))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("circle", {
                  style: {"fill":"blue","stroke":"none"},
                  cx: pz.value.r,
                  cy: -pz.value.i,
                  r: 5/_unref(geom).scale
                }, null, 8, _hoisted_63),
                ((mode.value == 'normal' || mode.value == 'zoom') && ! moving.value)
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 7,
                      style: {"fill":"blue"},
                      x: z.value.r + 5/_unref(geom).scale,
                      y: -z.value.i - 5/_unref(geom).scale,
                      "font-size": 30/_unref(geom).scale,
                      "text-anchor": "end"
                    }, [
                      _createTextVNode(" z "),
                      (showValue.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" = " + _toDisplayString(z.value.txt), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_64))
                  : _createCommentVNode("", true),
                ((mode.value == 'quot' || mode.value == 'qzoom') && ! moving.value)
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 8,
                      style: {"fill":"blue"},
                      x: c.value.r + 5/_unref(geom).scale,
                      y: -c.value.i - 5/_unref(geom).scale,
                      "font-size": 30/_unref(geom).scale
                    }, [
                      _createTextVNode(" z/w "),
                      (showValue.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" = " + _toDisplayString(c.value.intTxt), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_65))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_36)),
              _createElementVNode("div", _hoisted_66, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qlist.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    onClick: ($event: any) => (item.show = ! item.show)
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({cursor: 'pointer', background: item.valid ? (item.show ? '#fed' : '#ffd') : (item.show ? '#edd' : '#ddd') })
                    }, " q = " + _toDisplayString(item.q.txt), 5)
                  ], 8, _hoisted_67))
                }), 128))
              ]),
              (! moving.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    (mode.value == 'normal')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (newMode('zoom')))
                        }, " Zoom in "))
                      : _createCommentVNode("", true),
                    (mode.value == 'normal')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (newMode('quot')))
                        }, " 1/w 倍 "))
                      : _createCommentVNode("", true),
                    (mode.value == 'zoom')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (newMode('normal')))
                        }, " Zoom out "))
                      : _createCommentVNode("", true),
                    (mode.value == 'quot')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (newMode('qzoom')))
                        }, " Zoom in "))
                      : _createCommentVNode("", true),
                    (mode.value == 'quot')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (newMode('normal')))
                        }, " w 倍 "))
                      : _createCommentVNode("", true),
                    (mode.value == 'qzoom')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (newMode('quot')))
                        }, " Zoom out "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (showValue.value = ! showValue.value))
                    }, " 値の" + _toDisplayString(showValue.value ? '非' : '') + "表示 ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})